import { BATCH_JOB_STATUS_PROCESSING } from './constants';

export const normalizeDataArray = (entityName, idAttribute = 'id', dataArray, isCleanUp = false) => {
  const reducedData = dataArray.reduce((keyedData, datum) => {
    if (isCleanUp) {
      return keyedData;
    }

    return {
      ...keyedData,
      [datum[idAttribute]]: datum,
    };
  }, {});
  return {
    [entityName]: {
      ...reducedData,
    },
  };
};

export const buildEntityPayload = (normalizedEntityGroups) => ({
  entities: {
    ...normalizedEntityGroups,
  },
});

export const buildJobData = (jobGuids, fulfillmentPlanSetId) => {
  const jobs = [];
  const jobIdsToFpSetIdMap = {};

  jobGuids.forEach((id) => {
    jobs.push({ jobId: id, status: BATCH_JOB_STATUS_PROCESSING });
    jobIdsToFpSetIdMap[id] = fulfillmentPlanSetId;
  });

  return {
    jobs,
    jobIdsToFpSetIdMap,
  };
};
